import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { useLocation, useNavigate } from 'react-router-dom'
import { MainLayout } from 'views/layouts/'
import { Container, RowContainer, InfoUserContainer, InfoColumn, CardInfo, ReportContainer, BetesaMeasurementCard, BetesaMeasurementLabel, BetesaGroup, BetesaFollowUpList } from './styled'
import { H2, H5, H4, H3, P, SubtitleBold } from 'views/components/UI/Text'
import CardTypeTest from 'views/components/Cards/TestType'
import { BackButton } from 'views/components/UI/Buttons'
import { useNotification } from 'lib/context/notification.context'
import ModalLoader from 'views/components/UI/ModalLoader/modal-loader'
import skillIcon from 'assets/images/icon-skills-card.png'
import betesaIcon from 'assets/images/icon-betesa-card.png'
import test360Icon from 'assets/images/icon-test360-card.png'
import { orderTestsByProcess } from 'utils/common'
import getProcessDetailByUser from 'services/common/process/getProcessDetailByUser'
import { superAdminRoutes } from 'router/routes'
import { useTranslation } from 'react-i18next'
import { formatMeasurementDate } from 'utils/measurement-label'
import { skillsMeasurementGroups } from 'views/screens/Platform-administrator/EvaluatedDetail/skills-measurement-history'
import { MeasurementMeta } from 'views/screens/Platform-administrator/EvaluatedDetail/styled'

const measurementStatus = (measurement: { completed_test: boolean; answer_date?: string | null }): string => {
  if (!measurement.completed_test) return 'Pendiente'
  const date = formatMeasurementDate(measurement.answer_date)
  return date ? `Completada · Respuesta: ${date}` : 'Completada'
}

const DetailUserByCompany = () => {
  // Función para validar si una cadena es un UUID
  const isUUID = (str: string): boolean => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
    return uuidRegex.test(str)
  }

  const { t } = useTranslation()
  const { getError } = useNotification()
  const navigate = useNavigate()

  const { token } = useSelector((state: any) => state.user)

  const [userDetail, setUserDetail] = useState<any>(null)
  const [tests, setTests] = useState<any>(null)
  const [companiesHistory, setCompaniesHistory] = useState<any>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const location = useLocation()
  const { userData } = location.state
  const { process_id: processId } = userData
  const companyId = userData.companyId

  useEffect(() => {
    if (isLoading || !processId) return
    setIsLoading(true)
    getProcessDetailByUser(token, userData.id).then((res) => {
      if (res.status === 'OK') {
        setUserDetail(res.data.user_detail)
        setTests(orderTestsByProcess(res.data.tests as any))
        setCompaniesHistory(res.data.companies_history)
        setIsLoading(false)
      } else {
        getError(t('global.errorMessages.userDataError'))
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, userData.id, userData.process_id])

  return (
    <MainLayout>
      <>
        {processId ? (
          <Container>
            <div>
              <H2 margin="1.5% 2.3%">Espacio de evaluado {`${userData?.user_name}`}</H2>
            </div>
            <InfoUserContainer>
              <InfoColumn>
                <CardInfo>
                  <H5 margin="8px 0px">Datos personales</H5>
                  <RowContainer margin="8px 0px">
                    <P margin="0px 6px 0px 0px" weight={700}>
                      Nombre completo:{' '}
                    </P>
                    <P>{`${userData?.user_name}`}</P>
                  </RowContainer>
                  <RowContainer margin="2px 0px">
                    <P weight={700} margin="0px 6px 0px 0px">
                      {' '}
                      Fecha de nacimiento:{' '}
                    </P>
                    <P>
                      {userDetail?.user_birth_date}
                      {` (${dayjs().diff(dayjs(userDetail?.user_birth_date, 'DD/MM/YYYY'), 'year')}) años`}
                    </P>
                  </RowContainer>
                  <RowContainer margin="2px 0px">
                    <P weight={700} margin="0px 6px 0px 0px">
                      {' '}
                      Documento de identidad:{' '}
                    </P>
                    <P>
                      {userDetail?.user_document
                        ? isUUID(userDetail.user_document)
                          ? 'N/A'
                          : userDetail.user_document
                        : ''}
                    </P>
                  </RowContainer>
                </CardInfo>
              </InfoColumn>
              <InfoColumn>
                <CardInfo>
                  <H4 style={{ marginBottom: 20 }}>Procesos a los que pertenece</H4>
                  {companiesHistory && companiesHistory.length > 0 ? (
                    companiesHistory.map((company: any, index: number) => (
                      <RowContainer margin="2px 0px" key={index}>
                        <P>{company.process_name} - </P>
                        <P fontWeight={700}>{` ${company.company_name}`}</P>
                      </RowContainer>
                    ))
                  ) : (
                    <P>No hay procesos asociados a este usuario</P>
                  )}
                </CardInfo>
              </InfoColumn>
            </InfoUserContainer>
            <ReportContainer>
              <H3 margin="10px 0px">Pruebas realizadas</H3>

              {tests && tests.length > 0 ? (
                tests.map((process: any, index: number) => {
                  const betesaHistory = skillsMeasurementGroups(process.tests, 'Betesa Premium')
                  const skillsHistory = skillsMeasurementGroups(process.tests)
                  return (
                    <div key={index}>
                      <SubtitleBold fontSize="1.5rem">{process.process_name}</SubtitleBold>
                      <RowContainer margin="2px 0px" style={{ gap: '20px' }}>
                        {process.tests.filter((test: any) => !test.is_follow_up && !test.is_retake).map((test: any, indexItem: number) => {
                          const CardToRender =
                            test.category_name === 'Betesa Premium' ? (
                              <CardTypeTest
                                key={`process-test-index-${indexItem}`}
                                link={superAdminRoutes.ResultsBetesa}
                                params={{
                                  testId: test.test_id,
                                  userTestId: test.user_test_id,
                                  userName: userData.user_name,
                                  userId: userData.id,
                                  companyId,
                                  betesaResultId: test.betesa_test_id,
                                  processId: process.process_id,
                                  language: test.language,
                                }}
                                title={test.is_follow_up ? 'Betesa - Follow Up' : 'Betesa'}
                                image={betesaIcon}
                                disabled={test.domination === null}
                              />
                            ) : test.category_name === 'Competencias' ? (
                              <CardTypeTest
                                key={`process-test-competence-${indexItem}`}
                                link={superAdminRoutes.ResultsSkills}
                                params={{
                                  testId: test.test_id,
                                  userName: userData.user_name,
                                  userId: userData.id,
                                  companyId,
                                  userTestId: test.user_test_id,
                                  processId: process.process_id,
                                  language: test.language,
                                }}
                                title={t('global.common.skillText')}
                                image={skillIcon}
                                disabled={!test.completed_test}
                              />
                            ) : test.category_name === 'Prueba360' ? (
                              <CardTypeTest
                                key={`process-test-360-${indexItem}`}
                                link="/user-test-detail-360/"
                                params={{
                                  testId: test.test_id,
                                  userName: userData.user_name,
                                  userId: userData.id,
                                  companyId,
                                  processId: process.process_id,
                                  language: test.language,
                                }}
                                title={t('global.common.threeSixtyText')}
                                image={test360Icon}
                                is360={true}
                                disabled={!test.completed_test && !test.oneEvaluatorAnswered}
                                isSpecialAdmin={true}
                              />
                            ) : null
                          if (test.category_name === 'Betesa Premium' && !test.is_follow_up) {
                            const followUps = betesaHistory.groups.find(
                              (group) => group.original.user_test_id === test.user_test_id
                            )?.followUps || []
                            return (
                              <BetesaGroup key={`process-betesa-group-${indexItem}`}>
                                <BetesaMeasurementCard>
                                  <BetesaMeasurementLabel>Medición original</BetesaMeasurementLabel>
                                  <MeasurementMeta>{measurementStatus(test)}</MeasurementMeta>
                                  {CardToRender}
                                </BetesaMeasurementCard>
                                {followUps.length ? (
                                  <BetesaFollowUpList>
                                    {followUps.map((followUp, followUpIndex: number) => (
                                        <BetesaMeasurementCard key={`process-follow-up-${followUp.user_test_id}`} $isFollowUp>
                                          <BetesaMeasurementLabel $isFollowUp>
                                            Follow Up {followUpIndex + 1} de Betesa
                                          </BetesaMeasurementLabel>
                                          <MeasurementMeta>{measurementStatus(followUp)}</MeasurementMeta>
                                          <CardTypeTest
                                            link={superAdminRoutes.ResultsBetesa}
                                            params={{
                                              testId: followUp.test_id,
                                              userTestId: followUp.user_test_id,
                                              userName: userData.user_name,
                                              userId: userData.id,
                                              companyId,
                                              betesaResultId: followUp.betesa_test_id,
                                              processId: process.process_id,
                                              language: followUp.language,
                                            }}
                                            title="Betesa - Follow Up"
                                            image={betesaIcon}
                                            disabled={followUp.domination === null}
                                          />
                                        </BetesaMeasurementCard>
                                      ))}
                                  </BetesaFollowUpList>
                                ) : null}
                              </BetesaGroup>
                            )
                          }

                          if (test.category_name === 'Competencias' && !test.is_follow_up) {
                            const followUps = skillsHistory.groups.find(
                              (group) => group.original.user_test_id === test.user_test_id
                            )?.followUps || []
                            return (
                              <BetesaGroup key={`process-skills-group-${test.user_test_id}`}>
                                <BetesaMeasurementCard>
                                  <BetesaMeasurementLabel>Medición original · 3D Skills</BetesaMeasurementLabel>
                                  <MeasurementMeta>{measurementStatus(test)}</MeasurementMeta>
                                  {CardToRender}
                                </BetesaMeasurementCard>
                                {followUps.length ? (
                                  <BetesaFollowUpList>
                                    {followUps.map((followUp, followUpIndex: number) => (
                                      <BetesaMeasurementCard key={`process-skills-follow-up-${followUp.user_test_id}`} $isFollowUp>
                                        <BetesaMeasurementLabel $isFollowUp>
                                          Follow Up {followUpIndex + 1} de 3D Skills
                                        </BetesaMeasurementLabel>
                                        <MeasurementMeta>{measurementStatus(followUp)}</MeasurementMeta>
                                        <CardTypeTest
                                          link={superAdminRoutes.ResultsSkills}
                                          params={{
                                            testId: followUp.test_id,
                                            userName: userData.user_name,
                                            userId: userData.id,
                                            companyId,
                                            userTestId: followUp.user_test_id,
                                            processId: process.process_id,
                                            language: followUp.language,
                                          }}
                                          title="3D Skills - Follow Up"
                                          image={skillIcon}
                                          disabled={!followUp.completed_test}
                                        />
                                      </BetesaMeasurementCard>
                                    ))}
                                  </BetesaFollowUpList>
                                ) : null}
                              </BetesaGroup>
                            )
                          }

                          return CardToRender
                        })}
                        {process.tests.filter((retake: any) => retake.category_name === 'Betesa Premium' && retake.is_retake).map((retake: any, retakeIndex: number) => (
                          <BetesaMeasurementCard key={`process-retake-${retake.user_test_id}`} $isFollowUp>
                            <BetesaMeasurementLabel $isFollowUp>Nueva oportunidad {retakeIndex + 1} de Betesa</BetesaMeasurementLabel>
                            <CardTypeTest
                              link={superAdminRoutes.ResultsBetesa}
                              params={{
                                testId: retake.test_id,
                                userTestId: retake.user_test_id,
                                userName: userData.user_name,
                                userId: userData.id,
                                companyId,
                                betesaResultId: retake.betesa_test_id,
                                processId: process.process_id,
                                language: retake.language,
                              }}
                              title="Betesa - Nueva oportunidad"
                              image={betesaIcon}
                              disabled={retake.domination === null}
                            />
                          </BetesaMeasurementCard>
                        ))}
                        {betesaHistory.unlinked.map((followUp) => (
                          <BetesaMeasurementCard key={`unlinked-betesa-${followUp.user_test_id}`} $isFollowUp>
                            <BetesaMeasurementLabel $isFollowUp>
                              Follow Up de Betesa · Referencia original no disponible
                            </BetesaMeasurementLabel>
                            <MeasurementMeta>{measurementStatus(followUp)}</MeasurementMeta>
                            <CardTypeTest
                              link={superAdminRoutes.ResultsBetesa}
                              params={{
                                testId: followUp.test_id,
                                userName: userData.user_name,
                                userId: userData.id,
                                companyId,
                                userTestId: followUp.user_test_id,
                                betesaResultId: followUp.betesa_test_id,
                                processId: process.process_id,
                                language: followUp.language,
                              }}
                              title="Betesa - Follow Up"
                              image={betesaIcon}
                              disabled={followUp.domination === null}
                            />
                          </BetesaMeasurementCard>
                        ))}
                        {skillsHistory.unlinked.map((followUp) => (
                          <BetesaMeasurementCard key={`unlinked-skills-${followUp.user_test_id}`} $isFollowUp>
                            <BetesaMeasurementLabel $isFollowUp>
                              Follow Up de 3D Skills · Referencia original no disponible
                            </BetesaMeasurementLabel>
                            <MeasurementMeta>{measurementStatus(followUp)}</MeasurementMeta>
                            <CardTypeTest
                              link={superAdminRoutes.ResultsSkills}
                              params={{
                                testId: followUp.test_id,
                                userName: userData.user_name,
                                userId: userData.id,
                                companyId,
                                userTestId: followUp.user_test_id,
                                processId: process.process_id,
                                language: followUp.language,
                              }}
                              title="3D Skills - Follow Up"
                              image={skillIcon}
                              disabled={!followUp.completed_test}
                            />
                          </BetesaMeasurementCard>
                        ))}
                      </RowContainer>
                    </div>
                  )
                })
              ) : (
                <P>Este usuario no ha presentado ninguna prueba</P>
              )}
            </ReportContainer>
            <BackButton onClick={() => navigate(-1)} />
          </Container>
        ) : (
          <>
            <h1>Este usuario no tiene procesos asociados</h1>
          </>
        )}
      </>
      {processId && <ModalLoader isLoading={isLoading} />}
    </MainLayout>
  )
}

export default DetailUserByCompany
